// extracted by mini-css-extract-plugin
export default {"chartWrapper":"weeklyDataChart_chartWrapper__XsSc3"};